import { React } from 'react';

import AOS from 'aos';
import 'aos/dist/aos.css';


AOS.init({
    duration: 2000
});

function Bookingscreen() {

    return (

        <>
        </>
        
    )
}

export default Bookingscreen;
